import SettingTypes from '@/utils/setting-types'

export default {
  name: 'screen-four-leaf-clover',
  label: {
    title: '四叶草',
    icon: require('@/assets/icon-component-label_FourLeafClover.svg'),
    limit: -1
  },
  sort: 1006,
  data: {
    title: '四叶草',
    bgImage: '',
    blocks: []
  },
  settings: {
    title: {
      type: SettingTypes.input,
      label: '四叶草标题'
    },
    bgImage: {
      type: SettingTypes.image,
      label: '背景图片'
    },
    blocks: {
      type: SettingTypes.custom,
      component_name: 'ScreenBlocksSettings'
    }
  }
}
